import React from 'react';
import { Stack, Checkbox, Tooltip } from '@airbus/components-react';
import './AdvanceComboBox.scss';

// Props for AdvanceComboBoxRow component
interface AdvanceComboBoxRowProps {
  index: number; // Index of the option in the filteredOptions array
  style: React.CSSProperties; // Style for virtualization (from react-window)
  filteredOptions: AcbObjectType[]; // List of options to display
  handleOptionChange: (option: AcbObjectType) => void; // Handler for option selection
}

/**
 * AdvanceComboBoxRow
 * -----------------------------------------------------------------------------
 * Renders a single row (option) in the virtualized combo box list.
 *
 * Features:
 * - Displays a checkbox for the option.
 * - Indicates selection state based on selectedOptions.
 * - Used by react-window for efficient rendering of large lists.
 * - Receives virtualization style props for correct positioning.
 *
 * Props:
 * - index: Index of the option in the filteredOptions array.
 * - style: Style object for virtualization (from react-window).
 * - filteredOptions: Array of options to display.
 * - selectedOptions: Array of currently selected options.
 * - handleOptionChange: Handler for selecting/deselecting an option.
 *
 * This component is used internally by AdvanceComboBoxList for virtualized rendering.
 */
const AdvanceComboBoxRow: React.FC<AdvanceComboBoxRowProps> = ({
  index,
  style,
  filteredOptions,
  handleOptionChange,
}) => {
  // Get the option for the current row
  // console.log('filteredOptions', filteredOptions);
  const option = filteredOptions[index];
  return (
    <div style={style} key={option.name}>
      <Stack spacing="1-x">
        {/* Checkbox for the option, checked if selected */}
        <Tooltip label={option?.name}>
          <Checkbox
            className="advance-combo-checkbox"
            label={option.name}
            checked={!!option.checked}
            onMouseDown={(e) => e.stopPropagation()}
            onChange={() => {
              handleOptionChange(option);
            }}
            disabled={false}
            onPointerEnterCapture={undefined}
            onPointerLeaveCapture={undefined}
          />
        </Tooltip>
      </Stack>
    </div>
  );
};

export default AdvanceComboBoxRow;
